import { PictureSize } from '../types';

// Get URLs of video author's normal sized and 2X profile pictures
export const getAvatarImages = (pix?: PictureSize[]): string[] => {
  const defaultSrc = 'https://i.vimeocdn.com/portrait/default-blue_40x40';
  const defaultSrcSet = 'https://i.vimeocdn.com/portrait/default-blue_80x80';
  const size1x = 72;
  const size2x = 144;

  const src = pix?.find((p) => p.width === size1x)?.link || pix?.[1]?.link || defaultSrc;
  const srcSet = pix?.find((p) => p.width === size2x)?.link || pix?.[2]?.link || defaultSrcSet;

  return [src, `${srcSet} 2x`];
};
